// extracted by mini-css-extract-plugin
module.exports = {"form":"create-contact-form_form__1HRDl","emailField":"create-contact-form_emailField__pba4H","submitButton":"create-contact-form_submitButton__TBuaR"};